import Icon from './Icon'

function Chip({ label, onClick = () => {}, href, close = true, className = '' }) {
  if (href)
    return (
      <a className={`chip ${className}`} href={href}>
        {label}
        {close && <Icon id="close" classes="chip__close" />}
      </a>
    )

  return (
    <span className={`chip ${className}`} onClick={onClick}>
      {label}
      {close && <Icon id="close" classes="chip__close" />}
    </span>
  )
}

export default Chip
